<template>
  <footer>
    <cube-tab-bar
      class="navigation"
      v-model="selectedLabelDefault"
      :data="tabs"
      @click="clickHandler"
      @change="changeHandler"
    ></cube-tab-bar>
  </footer>
</template>

<script>
export default {
  name: "navigation",
  data() {
    return {
      selectedLabelDefault: "首页",
      tabs: [
        {
          label: "首页",
          icon: "cubeic-home"
        },
        {
          label: "分类",
          icon: "cubeic-tag"
        },
        {
          label: "搜索",
          icon: "cubeic-search"
        },
        {
          label: "购物车",
          icon: "cubeic-mall"
        },
        {
          label: "我的",
          icon: "cubeic-person"
        }
      ]
    };
  },

  methods: {
    clickHandler(label) {},
    changeHandler(label) {
      switch (label) {
        case "首页":
          this.$router.push({ path: "/" });
          break;
        case "分类":
          this.$router.push({ path: "/classification" });
          break;
        case "搜索":
          this.$router.push({ path: "/search" });
          break;
        case "购物车":
          this.$router.push({ path: "/shopCart" });
          break;
        case "我的":
          this.$router.push({ path: "/mine" });
          break;
        default:
          this.$router.push({ path: "/" });
          break;
      }
    }
  }
};
</script>

<style lang="stylus">
.cube-tab-bar.navigation {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 1000;
  width: 100%;
  background: #fff;

  .cube-tab div {
    font-size: 18px;
    padding-top: 3px;
  }
}
</style>
